module.exports = __webpack_public_path__ + "static/media/Reverse.d9c11364.png";